import { Skeleton } from '../components/ui/Skeleton'

export default function RouteLoadingFallback() {
  return (
    <section
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="min-h-[18rem] rounded-xl border border-slate-200 bg-white p-5 sm:p-6"
    >
      <div className="flex items-center gap-3 text-sm font-medium text-slate-600">
        <span
          aria-hidden="true"
          className="h-2.5 w-2.5 animate-pulse rounded-full bg-blue-600 motion-reduce:animate-none"
        />
        Loading page…
      </div>
      <div aria-hidden="true" className="mt-6 space-y-5">
        <Skeleton className="h-8 w-2/5 max-w-xs" />
        <div className="space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-11/12" />
          <Skeleton className="h-4 w-4/5" />
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-24 w-full" />
        </div>
      </div>
    </section>
  )
}
